/* global $:false */

import Select from './recordm.fields.select.js';

// Component capable of handling selection lists with a radio group
// Extends Select
//
// args:
// * `options`: A list of possible values
// * `confs`: the field configuration
//
// confs:
// * `id`: the input attr id
// * `cssClasses`: A string space separated with a list of css classes to add to the surrounding rediogroup div
// * `readonly`: true or false. Defaults to false
// * `valueChanged(newValue)`: Invoked when a user changes the value,
//
// * `defaultValue`: The default selected option
// * `allowEmptyOption`: If there is an empty option
//
var Radio = function(core) {
    this._core = core;

    /* eslint-disable-next-line prefer-rest-params */
    Select.apply(this, arguments);

    this._$radioBtns = [];
    this._radiogroupName = "radiogroup_" + this._confs.id;
};


Radio.prototype = new Select();
Radio.prototype.constructor = Radio;


Radio.prototype.render = function() {
    var _this = this;

    var $html = $([
        '<div class="radiogroup ' + _this._radiogroupName + '">',
        '</div>'
    ].join(''));

    this._$input = $html;

    if (this._confs.cssClasses) {
        this._$input.addClass(this._confs.cssClasses);
    }

    this._options.forEach(function(option) {
        _this._$input.append($('<label class="radio-inline">' +
                              '<input type="radio" name="' + _this._radiogroupName + '" value="' + option + '">' + option +
                              '</label>'));
    });

    if (this._confs.allowEmptyOption) {
        this._$input.append($('<a class="link js-clear-radio" >' +
                              this._core.translateString("recordm.instances", "instance.field.radio.clear") +
                              '</a>'));

        $(".js-clear-radio", this._$input).on('click', function() {
            _this._$radioBtns.prop('checked', false);
            _this.setValue("");
        });
    }

    this._$radioBtns = $("input[name='" + _this._radiogroupName + "']", this._$input);

    if (this._confs.defaultValue && this._lastValue === undefined) {
       _this._setValue(_this._confs.defaultValue);
    }

    if (this._confs.readonly) {
        this._$radioBtns.attr("disabled", "disabled").attr("tabindex", -1);
    } else {
        this._$radioBtns.on('change', function(){_this._onValueChange()});
    }

    if (this._lastValue) {
        _this.setValue(this._lastValue);
    } else {
        this._lastValue = this._$radioBtns.filter(":checked").val();
    }

    return $html;
};

Radio.prototype.destroy = function() {
    var _this = this;

    if (!this._confs.readonly) {
        this._$radioBtns.off('change', function(){_this._onValueChange()});
    }
};

Radio.prototype.setValue = function(value) {
    if (this._$input) {
        $('input[name="' + this._radiogroupName + '"][value="' + value + '"]', this._$input).prop('checked', true);
    }

    // Notify that this field has a new value because
    // I want to update the $auto.join and other fields...
    this._setValue(value);
};

Radio.prototype._onValueChange = function() {
    this._setValue(this._$radioBtns.filter(":checked").val());
};

Radio.getValueOf = function($container, radioGroupName) {
    return $container.find("input[name='"+radioGroupName +"']:checked").val();
};

Radio.prototype.disableSelf = function() {
    this._$radioBtns.prop("disabled", true).attr("tabindex", -1);
    $(".js-clear-radio", this._$input).addClass("hidden");
};

Radio.prototype.enableSelf = function() {
    this._$radioBtns.removeProp("disabled").removeAttr("tabindex");
    $(".js-clear-radio", this._$input).removeClass("hidden");
};

export default Radio;
